import { useAtom } from '@xstate/store/react';

import {
	activatePendingContent,
	audioPlayerState,
	clearPendingContent,
	closeAudioPlayer,
	getCustomization,
	getSupportingContent,
	openAudioPlayer,
	resetPlayImmediately,
	resetPlaylistDefaultExpanded,
	setActiveAudioContainerMode,
	setActiveFeature,
	setActiveMenu,
	setCustomization,
	setIsPaused,
	setIsPlaying,
	setPlaybackSpeed,
	setSupportingContent,
	updatePlayerState,
} from '../state/AudioPlayerState';

export const useAudioPlayerStore = () => {
	const state = useAtom(audioPlayerState);

	return {
		// State
		isOpen: state.isOpen,
		isPlaying: state.isPlaying,
		isPaused: state.isPaused,
		activeContent: state.activeContent,
		activeFeature: state.activeFeature,
		activeMenu: state.activeMenu,
		activeAudioContainerMode: state.activeAudioContainerMode,
		pendingContent: state.pendingContent,
		cloudId: state.cloudId,
		customization: state.customization,
		playlistDefaultExpanded: state.playlistDefaultExpanded,
		playImmediately: state.playImmediately,

		// Actions
		openAudioPlayer,
		closeAudioPlayer,
		activatePendingContent,
		clearPendingContent,
		setIsPlaying,
		setIsPaused,
		updatePlayerState,
		setActiveFeature,
		setActiveMenu,
		setActiveAudioContainerMode,
		setCustomization,
		getCustomization,
		setPlaybackSpeed,
		getSupportingContent,
		setSupportingContent,
		resetPlaylistDefaultExpanded,
		resetPlayImmediately,
	};
};
